/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ChainlinkV3PriceProvider,
  ChainlinkV3PriceProviderInterface,
} from "../ChainlinkV3PriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_emergencyManager",
        type: "address",
      },
      {
        internalType: "contract AggregatorV3Interface",
        name: "_quoteAggregator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_quoteAggregatorHeartbeat",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AggregatorDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "AggregatorPriceNotAvailable",
    type: "error",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "EmergencyManagerDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "EmergencyThresholdNotReached",
    type: "error",
  },
  {
    inputs: [],
    name: "FallbackProviderAlreadySet",
    type: "error",
  },
  {
    inputs: [],
    name: "FallbackProviderDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "FallbackProviderNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "HeartbeatDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAggregator",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAggregatorDecimals",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFallbackPriceProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidHeartbeat",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyEmergencyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "QuoteAggregatorHeartbeatDidNotChange",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract AggregatorV3Interface",
        name: "aggregator",
        type: "address",
      },
    ],
    name: "AggregatorDisabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract AggregatorV3Interface",
        name: "aggregator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "convertToQuote",
        type: "bool",
      },
    ],
    name: "NewAggregator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "emergencyManager",
        type: "address",
      },
    ],
    name: "NewEmergencyManager",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "fallbackProvider",
        type: "address",
      },
    ],
    name: "NewFallbackPriceProvider",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heartbeat",
        type: "uint256",
      },
    ],
    name: "NewHeartbeat",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "heartbeat",
        type: "uint256",
      },
    ],
    name: "NewQuoteAggregatorHeartbeat",
    type: "event",
  },
  {
    inputs: [],
    name: "EMERGENCY_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EMERGENCY_THRESHOLD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "assetData",
    outputs: [
      {
        internalType: "uint256",
        name: "heartbeat",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "forceFallback",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "convertToQuote",
        type: "bool",
      },
      {
        internalType: "contract AggregatorV3Interface",
        name: "aggregator",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "fallbackProvider",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "emergencyDisable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getAggregatorPrice",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getFallbackProvider",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteAggregatorHeartbeat",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract AggregatorV3Interface",
        name: "_aggregator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_convertToQuote",
        type: "bool",
      },
    ],
    name: "setAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_emergencyManager",
        type: "address",
      },
    ],
    name: "setEmergencyManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_fallbackProvider",
        type: "address",
      },
    ],
    name: "setFallbackPriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_heartbeat",
        type: "uint256",
      },
    ],
    name: "setHeartbeat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_heartbeat",
        type: "uint256",
      },
    ],
    name: "setQuoteAggregatorHeartbeat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract AggregatorV3Interface",
        name: "_aggregator",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_fallbackProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_heartbeat",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_convertToQuote",
        type: "bool",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ChainlinkV3PriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ChainlinkV3PriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ChainlinkV3PriceProvider__factory extends ContractFactory {
  constructor(...args: ChainlinkV3PriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ChainlinkV3PriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _emergencyManager: string,
    _quoteAggregator: string,
    _quoteAggregatorHeartbeat: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ChainlinkV3PriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _emergencyManager,
      _quoteAggregator,
      _quoteAggregatorHeartbeat,
      overrides || {}
    ) as Promise<ChainlinkV3PriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _emergencyManager: string,
    _quoteAggregator: string,
    _quoteAggregatorHeartbeat: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _emergencyManager,
      _quoteAggregator,
      _quoteAggregatorHeartbeat,
      overrides || {}
    );
  }
  attach(address: string): ChainlinkV3PriceProvider {
    return super.attach(address) as ChainlinkV3PriceProvider;
  }
  connect(signer: Signer): ChainlinkV3PriceProvider__factory {
    return super.connect(signer) as ChainlinkV3PriceProvider__factory;
  }
  static readonly contractName: "ChainlinkV3PriceProvider";
  public readonly contractName: "ChainlinkV3PriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ChainlinkV3PriceProviderInterface {
    return new utils.Interface(_abi) as ChainlinkV3PriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainlinkV3PriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ChainlinkV3PriceProvider;
  }
}
